import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { CriteriaDefDTO } from '../../api/plyca-dtos-v2';
import { Component, OnInit, Optional, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpType } from '../../components/common/help/help.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';

// templateUrl: 'customField.edition.template.html'
@Component({
  selector: 'criteriaDef-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class CriteriaDefEditionComponent
  extends BaseFormComponent<CriteriaDefDTO, CriteriaDefDTO>
  implements OnInit {
  private identifier: string;

  constructor(
    elem: ElementRef,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.windowHash = generateRandomIdentifier();
  }

  getFormSettingURL(): string {
    return 'admin/criteriaDefISettings.json';
  }

  getServiceURL(): string {
    return this.configuration.CRITERIADEF_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }

  dtoToModel(dto: CriteriaDefDTO): Observable<CriteriaDefDTO> {
    return of(dto);
  }

  modelToDTO(model: CriteriaDefDTO): CriteriaDefDTO {
    return model;
  }

  getTitle(model: CriteriaDefDTO): string {
    if (model) {
      return model.identifier + ' - ' + model.description;
    } else {
      return 'Nuevo grupo';
    }
  }

  // getProjectId(): string {
  //   return this.model.dto.project.identifier;
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Communications.detail.form.title';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.searchTags = [HelpType.EDIT_CRITERIA_DEF];
    // formConfig.readonly = this.readonly;
    return of(formConfig);
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);


    this.subscribe(
      this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash)
      ,
      () => {
        this.subscribe(this.save()
          , () => this.close(),
          () => {
            // Si es un FATAL o un error no controlado de servidor
            this.waitService.cancelWaiting();

          }
        );

      }

    )


    // this.headerActionsService.addWindowDivider(this.windowHash);
    // this.addBackAction();
  }

  close() {
    this.ref.close();
    this.waitService.cancelWaiting();
  }
}
